import { render, staticRenderFns } from "./addProductForm.vue?vue&type=template&id=c8279970"
import script from "./addProductForm.vue?vue&type=script&lang=js"
export * from "./addProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports